// import { CustomPopover } from '../../../components/custom-popover';
import { SvgIcon } from '../../../components/svg-icon';
import { SvgIconName } from '../../../components/svg-icon/model';
// import { Button } from 'antd';
import React from 'react';
import './index.scss';
import copy from 'copy-to-clipboard';
import { messageSuccess } from '../../../components/message';
import getFormatMessage from '../../../locales/get-format-message';
import { PermissionCheck } from '../../component/permission-check';
import { RbacRoleObjectKey } from '../../../model/rbac';

export interface IGameSettingItemInfo {
  readonly left: React.ReactNode | string;
  readonly right: React.ReactNode | string;
  readonly copyConfig?: {
    readonly disabled: boolean;
    readonly text: string;
  };
  readonly editConfig?: {
    readonly disabled: boolean;
    readonly onEdit: () => void;
    readonly editing: boolean;
  };
}

interface IProps {
  readonly items: ReadonlyArray<IGameSettingItemInfo>;
}

/**
 * @description studio or game setting page layout
 */
export const GameSettingInfoLayout = (props: IProps) => {
  const onCopy = (item: IGameSettingItemInfo) => {
    if (item.copyConfig) {
      copy(item.copyConfig.text);
      messageSuccess(getFormatMessage('copy_clipboard'));
    }
  };

  const renderRow = (item: IGameSettingItemInfo, index: number) => {
    return (
      <div className="column-layout" key={index}>
        <div className="row-label">{item.left}</div>
        <div className="row-value">{renderRightItem(item)}</div>
      </div>
    );
  };

  const renderCopyIcon = (item: IGameSettingItemInfo) => {
    return (
      <SvgIcon
        icon={SvgIconName.Copy}
        className="action-icon pointer m-l"
        onClick={() => onCopy(item)}
      />
    );
  };

  const renderEditIcon = (item: IGameSettingItemInfo) => {
    if (item.editConfig) {
      if (item.editConfig.editing) {
        return null;
      }

      return (
        <PermissionCheck permissionKey={RbacRoleObjectKey.StudioPut}>
          <span className="studio-rename-icon">
            <SvgIcon
              icon={SvgIconName.StudioNameEdit}
              className="icon-edit action-icon pointer m-l"
              onClick={item.editConfig?.onEdit}
            />
          </span>
        </PermissionCheck>
      );
    }
    return null;
  };

  const renderRightItem = (item: IGameSettingItemInfo) => {
    return (
      <>
        <span className="right-content">{item.right}</span>
        {item.copyConfig ? renderCopyIcon(item) : null}
        {renderEditIcon(item)}
      </>
    );
  };

  return (
    <>
      <div className="studio-setting-info-component">
        <div className="set-info-title">{getFormatMessage('studio_info')}</div>
        <div className="info-layout">
          {props.items.map((item, index) => {
            return renderRow(item, index);
          })}
        </div>
      </div>
    </>
  );
};
